import{css as e}from"lit";var t=e`cds-search input[type=search]::-webkit-search-cancel-button{display:none}`;export default t;
